import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import styled from 'styled-components';
import { Stack } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { toast } from 'react-toastify';
const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled(Box)`
  background-color: white;
  border-radius: 12px;
  width: 90vw;
  max-width: 500px;
  min-height: 90vh;
  overflow-y: auto;
  padding: 20px;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  @media (min-width: 768px) {
    padding: 30px;
  }
`;

const Title = styled.h2`
  margin: 0;
  margin-bottom: 20px;
  font-size: 1.5rem;
  margin-top: -15px;
`;

const CloseDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
`;

const IframeContainer = styled.div`
  width: 100%;
  height: 80vh;
  position: relative;
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1;
`;

const WaitlistFormModal = ({ open, onClose, wheelData }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    // Check if referralData exists in sessionStorage
    let referralData = sessionStorage.getItem('referralData');

    if (!referralData && wheelData?.user_profile) {
      // Set referralData from wheelData.user_profile
      const { referral_code } = wheelData?.user_profile;
      const { first_name, last_name } = wheelData?.referral_name;

      const userReferralData = { first_name, last_name, referral_code };

      // Update sessionStorage
      sessionStorage.setItem('referralData', JSON.stringify(userReferralData));
      referralData = JSON.stringify(userReferralData);
    }

    // Update state with parsed referralData
    if (referralData) {
      setData(JSON.parse(referralData));
    }
  }, []);


  console.log(data?.first_name, wheelData?.user_profile?.first_name, "=1p4=1304=1304=1")
  const onShareClick = () => {
    navigator.clipboard
      .writeText(
        `https://link.iyuga.net/widget/form/nmFYpxh6lKbPpjthvU4i?referral_first_name=${data?.first_name || wheelData?.user_profile?.first_name || ''
        }&referral_last_name=${data?.last_name || wheelData?.user_profile?.last_name || ''}&how_did_you_hear_about_iyuga=Friend+or+Associate+Referral`
      )
      .then(() => {
        toast.success('URL copied to clipboard!');
      })
      .catch((err) => {
        console.error('Failed to copy URL: ', err);
      });
  };

  return (
    <StyledModal open={open} onClose={onClose}>
      <ModalContainer>
        <Stack direction="row" spacing={2} justifyContent="space-between" mb={2}>
          <Title>It’s Your Lucky Day!</Title>

          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
            <ShareIcon
              onClick={onShareClick}
              style={{ fontSize: '18px', cursor: 'pointer', marginRight: '5px' }}
            />
            <CloseIcon onClick={onClose} style={{ cursor: 'pointer' }} />
          </Stack>
        </Stack>

        <IframeContainer>
          {loading && (
            <LoaderWrapper>
              <CircularProgress />
            </LoaderWrapper>
          )}

          <iframe
            src={`https://link.iyuga.net/widget/form/nmFYpxh6lKbPpjthvU4i?referral_first_name_beta=${wheelData?.referral_name?.first_name || data?.first_name || ''
              }&referral_last_name_beta=${wheelData?.referral_name?.last_name || data?.last_name || ''
              }&how_did_you_hear_about_iyuga=Friend+or+Associate+Referral`}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="iYuga Widget Form"
            allowFullScreen
            onLoad={() => setLoading(false)}
          ></iframe>
        </IframeContainer>
      </ModalContainer>
    </StyledModal>
  );
};

export default WaitlistFormModal;
